module.exports = __webpack_public_path__ + "static/media/eye-grey.116a54c0.svg";